<template>
    <LayoutContainer class="display-composite-collection">
        <GridContainer class="gap-y-10">
            <GridColumn
                v-if="categorisedItems.hero"
                class="col-span-12"
            >
                <component
                    :is="categorisedItems.hero.component"
                    :resource="categorisedItems.hero.resource"
                    :inline="true"
                    class="display-composite-collection__hero"
                ></component>
            </GridColumn>
            <GridColumn
                v-for="item in categorisedItems.items"
                :key="item.resource.id"
                :class="columnClasses"
            >
                <component
                    :is="item.component"
                    :resource="item.resource"
                ></component>
            </GridColumn>
        </GridContainer>
        <button
            v-if="this.resolvedItems > this.visibleItems"
            class="text-action mx-auto block mt-10 lg:mt-25 border border-midnight px-4 pt-2 pb-3"
            @click="showMore"
        >
            show more
            <span class="text-3xl relative top-0.5">
                +
            </span>
        </button>
    </LayoutContainer>
</template>

<script>
import Kernel from "@oilstone/kernel"
import {inject} from "vue";

export default {
    setup() {
        const type = inject('type');

        return {
            type
        };
    },

    props: {
        filter: null,
        itemsPerRow: {
            type: Number,
            default: 4
        },
        hero: {
            type: Boolean,
            default: false
        },
        rows: {
            type: Number,
            default: 5
        },
    },

    data() {
        return {
            items: [],
            show: this.hero ? 1 + ((this.rows - 1) * this.itemsPerRow) : this.rows * this.itemsPerRow
        }
    },

    computed: {
        columnClasses() {
            const classes = ['col-span-12'];

            switch (this.itemsPerRow) {
                case 4:
                    classes.push('lg:col-span-3');
                    break;

                case 2:
                    classes.push('lg:col-span-6');
                    break;
            }

            return classes;
        },

        resolvedItems() {
            let filter = this.filter;

            if (!filter) {
                filter = items => items;
            }

            const items = this.items.map(item => {
                const config = Kernel.resolve('resourceRegistry').find(item.type).config;

                return {
                    type: item.type,
                    component: config.components.webCollectionItem.name,
                    resource: item.resource
                }
            });

            return filter(items);
        },

        visibleItems() {
            return this.resolvedItems.slice(0, this.show);
        },

        categorisedItems() {
            if (!this.visibleItems.length) {
                return [];
            }

            if (this.hero) {
                return {
                    hero: this.visibleItems[0],
                    items: this.visibleItems.slice(1)
                }
            }

            return {
                hero: null,
                items: this.visibleItems
            }
        }
    },

    methods: {
        showMore() {
            this.show += this.itemsPerRow;
        }
    },

    mounted() {
        Kernel.resolve('resourceRegistry').find(this.type).repository.listing().then(items => {
            this.items = items;

            this.$emit('retrieved', items);
        });
    }
}
</script>

<style>
.display-composite-collection {
    @apply mb-10 lg:mb-30;

    &__hero {
        .poster__content {
            @screen lg {
                @apply text-3xl font-heading;
            }
        }
    }
}
</style>
